// extracted by mini-css-extract-plugin
export default {"root":"StockListModal_root__DwVH+"};